import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { CustomProductsService } from '../custom-products.service';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { CustomProductCardComponent } from '../custom-product-card/custom-product-card.component';

@Component({
    selector: 'app-custom-product-carousel',
    templateUrl: './custom-product-carousel.component.html',
    styleUrls: ['./custom-product-carousel.component.scss'],
    imports: [NgIf, NgClass, DragScrollComponent, NgFor, DragScrollItemDirective, CustomProductCardComponent]
})
export class CustomProductCarouselComponent implements OnInit {
  @ViewChild('nav', { read: DragScrollComponent }) ds: DragScrollComponent;
  @Input() item: any;
  @Input() index: number;
  @Input() browseType: any;
  port = false;
  clickRgtBtn = true;
  clickLftBtn = true;
  removeContainer = true;
  constructor(
    private router: Router,
    private customProductService: CustomProductsService) { }
  ngOnInit(): void {
    this.customProductService.refreshComp$.subscribe(result => {
      this.reachesRightBound(false);
    });
  }
  moveLeft(): any {
    this.ds.moveLeft();
  }
  moveRight(): any {
    this.removeContainer = false;
    this.ds.moveRight();
  }
  moveTo(index): any {
    this.ds.moveTo(index);
  }
  navigateToQuote(): any {
    this.router.navigate([`/quotes`]);
  }
  leftBoundStat(event): any {
    if (event) {
      this.removeContainer = true;
    } else {
      this.removeContainer = false;
    }
    this.clickLftBtn = event;
  }
  reachesRightBound(event): any {
    this.clickRgtBtn = event;
  }
  onDragScrollInitialized(): any {
  }
}
